import { useUserContext } from '~/providers/user-provider'

export const useExperiment = (experimentId: string) => {
	const { userQuery } = useUserContext()

	return userQuery.isSuccess && !!userQuery.data?.experiments?.[experimentId]
}
